import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/logo2.png'


const _hoisted_1 = {
  href: "/",
  class: "brand-logo"
}
const _hoisted_2 = { href: "https://www.linkedin.com/in/yan-christoffer-4b401a135/" }
const _hoisted_3 = { href: "https://github.com/yanccprogramador" }
const _hoisted_4 = { href: "https://www.instagram.com/yaaan_chris/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        elevation: 2,
        theme: "dark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_title, null, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_1, [
                _createVNode(_component_v_img, {
                  style: {"width":"50px","height":"50px"},
                  class: "brand-logo img-responsive",
                  src: _imports_0,
                  alt: "Yan Christoffer"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_list, {
            class: "d-flex",
            nav: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Home")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "career" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Carreira")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "blog" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Blog")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, {
        class: "text-center d-flex flex-column",
        theme: "dark",
        fixed: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("a", _hoisted_2, [
                  _createVNode(_component_v_btn, {
                    class: "mx-4",
                    icon: "mdi-linkedin",
                    variant: "text"
                  })
                ]),
                _createElementVNode("a", _hoisted_3, [
                  _createVNode(_component_v_btn, {
                    class: "mx-4",
                    icon: "mdi-github",
                    variant: "text"
                  })
                ]),
                _createElementVNode("a", _hoisted_4, [
                  _createVNode(_component_v_btn, {
                    class: "mx-4",
                    icon: "mdi-instagram",
                    variant: "text"
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createTextVNode("Yan Christoffer© 2023")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}